export default __webpack_public_path__ + "static/media/landscape_city_from_belvedere.222a518f.jpg";